import BaseCommand from "@/models/api/commands/BaseCommand";

export class DuplicateOrderItemCommand extends BaseCommand {
  CommandName = "DuplicateOrderItem";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
